import { Editor } from 'grapesjs';
import { faUsersCrown } from '@fortawesome/pro-solid-svg-icons/faUsersCrown';
import { EditorComponentDefinition } from '../types';
import { LeaderboardTableGrapesComponent } from './leaderboard-table-grapes-component';
import { Toolbar } from '../../utils';
import { markChildrenWithParentType } from '../../../services/copy-paste/copy-paste-utils';

export const leaderboardComponentDefinition: EditorComponentDefinition = {
  id: 'leaderboard',
  icon: faUsersCrown,
  category: 'Gamification',
  getLabel: ({ t }) => t('editor.component.leaderboard'),
  component: LeaderboardGrapesComponent,
  copyPasteHelper: markChildrenWithParentType,
  hidden: true,
};

export function LeaderboardGrapesComponent(editor: Editor) {
  LeaderboardTableGrapesComponent(editor);

  const languages = editor.Config?.context?.languages || [];

  editor.DomComponents.addType(leaderboardComponentDefinition.id, {
    isComponent: (el: HTMLElement) => {
      return el.tagName === 'DIV' && el.classList.contains('qlfeditor-leaderboard');
    },
    model: {
      defaults: {
        tagName: 'div',
        category: 'content',
        components: [
          {
            type: 'custom-text',
            attributes: {
              style: 'margin-bottom: 1em;',
            },
            draggable: false,
            droppable: false,
            copyable: false,
            i18nAttributes: {
              ...Object.fromEntries(
                languages.map((language: string) => [
                  language,
                  {
                    content: `
                  <div class="ql-snow">
                    <div class="ql-editor">
                      <h1 class="qlfeditor-title ql-align-center">${editor.I18n.t(
                        'editor.leaderboard.title',
                        { l: language },
                      )}</h1>
                    </div>
                  </div>
                `,
                  },
                ]),
              ),
            },
          },
          {
            type: 'leaderboard-table',
          },
        ],
        attributes: {
          class: 'qlfeditor-leaderboard',
        },
        traits: [],
        droppable: false,
        draggable: '[data-gjs-type=column]',
      },
      initToolbar: Toolbar,
    },
  });
}
